import { makeStyles } from "@saleor/macaw-ui";

export const useStyles = makeStyles(
  () => ({
    toolbar: {
      display: "flex",
    },
  }),
  { name: "CategoryProducts" },
);
